export default __webpack_public_path__ + "static/media/white-rectangle-bar.41d1b614.svg";